<h1 mat-dialog-title class="role-dialog-title">Benutzerrolle für {{ data.user.vorname }} {{ data.user.nachname }} auswählen</h1>
<mat-dialog-content class="role-dialog-content">
    <h5 class="role-dialog-subtitle">Neue Benutzerrolle auswählen</h5>
    <mat-form-field appearance="outline" class="role-dialog-field">
        <mat-select multiple [compareWith]="compareRoles" [(value)]="data.user.benutzerrollen">
            <mat-option *ngFor="let ur of userroles" [value]="ur">{{ ur.bezeichnung }}</mat-option>
        </mat-select>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions class="role-dialog-actions">
    <button mat-button color="primary" (click)="onCancelClick()">Abbrechen</button>
    <button mat-flat-button color="accent" (click)="safeAndCloseDialog()">Ändern</button>
</mat-dialog-actions>
